import { Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { I18nService } from '@app/i18n/services';
import { FeedbackService, FeedbackStyle, FeedbackTitle } from '@services/feedback';
import { ProgressIndicatorService } from '@services/progress';
import { UsersService } from '../../../../../../services/users';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';

import { FormsService } from '../../../../../../services/forms';
import { FormEditorInputType } from '../../../../../../shared/components';
import { IUserAccountMigrationDialogData } from './users-account-migration.models';

@Component({
	selector: 'app-users-account-migration',
	templateUrl: './users-account-migration.dialog.html'
})
export class UsersAccountMigrationDialogComponent extends OnDestroyMixin {
	public formEditorInputType = FormEditorInputType;
	public formInputs = this.formBuilder.group({
		email: ['', [this.formsService.emailValidator()]]
	});

	constructor(
		private i18nService: I18nService,
		private feedbackService: FeedbackService,
		private usersService: UsersService,
		private progressIndicatorService: ProgressIndicatorService,
		@Inject(MAT_DIALOG_DATA) public dialogData: IUserAccountMigrationDialogData,
		private dialogRef: MatDialogRef<UsersAccountMigrationDialogComponent>,
		private formBuilder: FormBuilder,
		private formsService: FormsService
	) {
		super();
	}

	public onFormSubmit(): void {
		this.feedbackService.confirm({
			title: FeedbackTitle.warning,
			message: this.i18nService.get('Are you sure you want to migrate this user?', 'app.prompt.users.migrate.confirm-message'),
			style: FeedbackStyle.error,
			callback: (confirmed: boolean) => {
				if (confirmed) {
					this.migrateUser();
				} else {
					this.dialogRef.close();
				}
			}
		});
	}

	private migrateUser(): void {
		this.progressIndicatorService.spinner(true);

		this.usersService
			.usersMigrateGigya(this.formInputs.controls.email.value)
			.subscribe(
				(res: boolean) => {
					this.progressIndicatorService.spinner(false);

					if (res) {
						this.dialogData.callback(null, true);
						this.feedbackService.notification({
							msg: this.i18nService.get('User migrated.', 'app.descriptor.users.user-migrated'),
							config: { duration: 4000 }
						});
						this.dialogRef.close();
					} else {
						this.feedbackService.plain({
							title: FeedbackTitle.attention,
							message: this.i18nService.get('Failed to migrate user account.', 'app.descriptor.users.user-not-migrated'),
							style: FeedbackStyle.error
						});
					}
				},
				(error: any) => {
					this.feedbackService.apiError(error);
					this.progressIndicatorService.spinner(false);
				}
			);
	}
}
